import React, { useContext, useRef } from "react";
import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthContext, base_url } from "../context/Authcontext";
import LoginReg from "./LoginReg";
import axios, { all } from "axios";
import { sharedGet, sharedPost } from "../utils/sharedGet";
import ToastMessage from "./ToastMessage";
import toast from "react-hot-toast";
import "../index.css";
import { FaRegClipboard } from "react-icons/fa";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useTheme } from "../context/ThemeContext";
import LoginModal from "./LoginModal";
import { Modal, Table } from "react-bootstrap";
import { formatINR } from "../utils/money";
import { setLiveCounts } from "../utils/liveCounts";

import { io } from "socket.io-client";

// Use the build-time API base URL so the socket connects to the same origin
// that nginx is proxying /socket.io/ on. Hardcoding localhost broke
// fancyGameWinEmitSocket in prod (browsers tried ws://localhost:3004).
const socket = io(base_url, {
  transports: ["websocket"],
});

const formatDate = (date) => {
  const d = new Date(date); // Ensure it's a Date object

  if (isNaN(d.getTime())) {
    console.warn("Invalid date passed to formatDate:", date);
    return "";
  }

  const year = d.getFullYear();
  const month = (d.getMonth() + 1).toString().padStart(2, "0");
  const day = d.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
};
const checkOpenDate = (openDate) => {
  // console.log(openDate,"opendate")
  const currentTime = new Date();
  const eventDate = new Date(openDate);

  // console.log(currentTime,eventDate,"cejc");

  // Convert both times to IST
  const currentIST = new Date(
    currentTime.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );
  const eventIST = new Date(
    eventDate.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );

  if (eventIST <= currentIST) {
    // console.log(eventIST,"----------------");

    return "InPlay";
  }

  const isToday =
    currentIST.getFullYear() === eventIST.getFullYear() &&
    currentIST.getMonth() === eventIST.getMonth() &&
    currentIST.getDate() === eventIST.getDate();

  if (isToday) {
    return "Today";
  }

  // Else return formatted date
  return `${eventIST.getDate().toString().padStart(2, "0")}-${(
    eventIST.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${eventIST.getFullYear()}`;
};

const compareWithToday = (openDate) => {
  const now = new Date();

  // Get today's date
  const today = formatDate(now);

  // Get tomorrow's date by adding 1 day to the current date
  const tomorrow = formatDate(new Date(now.getTime() + 24 * 60 * 60 * 1000)); // 24 hours in milliseconds

  // Convert openDate string to Date object
  const eventDateObj = new Date(openDate);

  const eventDateFormatted = formatDate(eventDateObj);

  return eventDateFormatted === today || eventDateFormatted === tomorrow;
};

/* =====================================================================
   Header chrome — announcement strip and primary navigation
   =====================================================================
   Both are shared by the logged-out and logged-in headers, which used to
   carry two near-identical copies of an eleven-item nav that had drifted
   apart (one had Ludo, the other had TableGames).

   The top level is four destinations. Individual sports and casino
   categories live one level down, inside the Sports and Casino panels,
   so a new sport can be added later without rebuilding the nav.
   ===================================================================== */

// The sub-navigation behind "Sports". countKey maps onto the live counts
// the header already polls for, so the panel can show what is running now.
const NAV_SPORTS = [
  { label: "All sports", path: "/sportall", icon: "fa-trophy" },
  { label: "Cricket", path: "/cricketreal", countKey: "cricket", icon: "fa-baseball-ball" },
  { label: "Football", path: "/footballreal", countKey: "football", icon: "fa-futbol" },
  { label: "Tennis", path: "/tennisreal", countKey: "tennis", icon: "fa-table-tennis" },
];

// `list` is the same category index CasinoGames.js filters by, so each
// entry lands on that category already selected.
/* Casino = a dealer, a table, cards or a wheel. Live Casino leads it
   rather than sitting beside it in the top bar: it used to be its own
   top-level item AND a dropdown entry AND a quick-access card, which is
   three doors into one room. */
const NAV_CASINO = [
  { label: "All casino", list: 0, icon: "fa-dice" },
  { label: "Live Casino", list: 7, icon: "fa-video" },
  { label: "Roulette", list: 9, icon: "fa-circle-notch" },
  { label: "Baccarat", list: 10, icon: "fa-clone" },
  { label: "Blackjack", list: 15, icon: "fa-layer-group" },
  { label: "Teen Patti", list: 4, icon: "fa-star" },
  { label: "Poker", list: 14, icon: "fa-diamond" },
  { label: "Table Games", list: 18, icon: "fa-chess-board" },
  { label: "Indian Games", list: 5, icon: "fa-hand-sparkles" },
];

/* Games = fast, solo, no dealer. Splitting these out is what stops
   "Casino" meaning "everything that is not a sport": it was one menu of
   nine mixed entries, and it is now two of six or seven that each say
   something. It also gives Crash somewhere to live. */
const NAV_GAMES = [
  { label: "All games", list: 21, icon: "fa-gamepad" },
  { label: "Crash games", list: 11, icon: "fa-plane" },
  { label: "Slots", list: 16, icon: "fa-coins" },
  { label: "Jili games", list: 6, icon: "fa-bolt" },
  { label: "Matka", path: "/matka", icon: "fa-dice-d6" },
];

/* A thin strip of trust signals. It replaces a scrolling marquee that
   spent a full row of vertical space on advertising copy; on a laptop
   every 20px of chrome is 20px the sportsbook does not get. */
const RbAnnounce = ({ clock }) => (
  <div className="rb-announce">
    <span className="rb-announce__item">
      <i className="fa fa-lock" aria-hidden="true" /> Secure payments
    </span>
    <span className="rb-announce__sep" aria-hidden="true">
      &bull;
    </span>
    <Link to="/contact-us" className="rb-announce__item rb-announce__item--drop rb-announce__link">
      <i className="fa fa-headphones" aria-hidden="true" /> 24/7 support
    </Link>
    <span className="rb-announce__sep rb-announce__item--drop" aria-hidden="true">
      &bull;
    </span>
    <span className="rb-announce__item">18+ only</span>
    {clock ? <span className="rb-announce__clock">{clock}</span> : null}
  </div>
);

/* Search. CasinoGames already had a searchText state and a filter behind
   it, but nothing anywhere ever called setSearchText -- there was no input
   on the page, so the feature was unreachable. This is the missing input;
   it hands the query to /casinoGames, which seeds its filter from it. */
const RbSearch = ({ compact }) => {
  const navigate = useNavigate();
  const [q, setQ] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const query = q.trim();
    if (!query) return;
    // list 0 is All Casino -- searching inside one category would silently
    // hide most of the matches.
    navigate("/casinoGames", { state: { list: 0, q: query } });
    setQ("");
  };

  return (
    <form
      className={compact ? "rb-topsearch rb-topsearch--compact" : "rb-topsearch"}
      role="search"
      onSubmit={submit}
    >
      <i className="fa fa-search" aria-hidden="true" />
      <input
        type="search"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search games"
        aria-label="Search games"
      />
    </form>
  );
};

const RbNav = ({ liveCounts }) => {
  const counts = liveCounts || {};
  const navigate = useNavigate();
  const location = useLocation();
  const [openPanel, setOpenPanel] = useState(null);
  // Where to draw the open panel. It is position:fixed (see the CSS note
  // -- the nav strip is a scroll container and clips anything absolutely
  // positioned inside it), so it needs real viewport coordinates.
  const [panelAt, setPanelAt] = useState({ left: 0, top: 0 });
  const navRef = useRef(null);

  // A panel left open after navigating, or after a click elsewhere on the
  // page, is the classic dropdown bug. Both are closed here.
  useEffect(() => {
    setOpenPanel(null);
  }, [location.pathname]);

  useEffect(() => {
    const onDocClick = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) setOpenPanel(null);
    };
    const onEsc = (e) => {
      if (e.key === "Escape") setOpenPanel(null);
    };
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, []);

  const sportPaths = ["/cricketreal", "/footballreal", "/tennisreal", "/sportall", "/inplay"];
  const isSports = sportPaths.indexOf(location.pathname) !== -1;
  // Both menus land on /casinoGames, so the active one is decided by the
  // category rather than the path.
  const navList = location.state && location.state.list;
  const GAME_LISTS = [21, 11, 16, 6];
  const onCasinoPath = location.pathname === "/casinoGames";
  // /matka is deliberately absent: that page renders no header and no nav
  // at all -- it is a standalone full-screen board with its own Back
  // button -- so a rule matching it could never light anything up.
  const isGames = onCasinoPath && GAME_LISTS.indexOf(navList) !== -1;
  const isCasino = onCasinoPath && !isGames;
  const isHome = location.pathname === "/" || location.pathname === "/home";

  const totalLive =
    (Number(counts.cricket) || 0) +
    (Number(counts.football) || 0) +
    (Number(counts.tennis) || 0);

  const placeFrom = (el) => {
    if (!el) return;
    const r = el.getBoundingClientRect();
    // Keep it on screen: a panel opened from the last item would otherwise
    // run off the right edge.
    const width = 220;
    const left = Math.min(r.left, window.innerWidth - width - 12);
    setPanelAt({ left: Math.max(8, left), top: r.bottom + 1 });
  };

  const open = (name, el) => {
    placeFrom(el);
    setOpenPanel(name);
  };

  const toggle = (name, el) => {
    if (openPanel === name) {
      setOpenPanel(null);
      return;
    }
    open(name, el);
  };

  // A fixed panel does not travel with the page, so it would sit still
  // while the nav scrolled away underneath it.
  useEffect(() => {
    if (!openPanel) return undefined;
    const close = () => setOpenPanel(null);
    window.addEventListener("scroll", close, { passive: true });
    window.addEventListener("resize", close);
    return () => {
      window.removeEventListener("scroll", close);
      window.removeEventListener("resize", close);
    };
  }, [openPanel]);

  return (
    <nav className="rb-nav" aria-label="Primary">
      <div className="rb-nav__inner" ref={navRef}>
        <button
          type="button"
          className={isHome ? "rb-nav__link rb-nav__link--active" : "rb-nav__link"}
          onClick={() => navigate("/")}
        >
          Home
        </button>

        <div className="rb-nav__item" onMouseLeave={() => setOpenPanel(null)}>
          <button
            type="button"
            className={isSports ? "rb-nav__link rb-nav__link--active" : "rb-nav__link"}
            aria-expanded={openPanel === "sports"}
            aria-haspopup="true"
            onClick={(e) => toggle("sports", e.currentTarget)}
            onMouseEnter={(e) => open("sports", e.currentTarget)}
          >
            Sports
            <span className="rb-nav__caret" aria-hidden="true">
              &#9660;
            </span>
          </button>
          {openPanel === "sports" && (
            <div className="rb-nav__panel" role="menu" style={panelAt}>
              {NAV_SPORTS.map((s) => (
                <button
                  key={s.label}
                  type="button"
                  role="menuitem"
                  className="rb-nav__panel-link"
                  onClick={() => navigate(s.path)}
                >
                  <i className={"fa " + s.icon} aria-hidden="true" />
                  {s.label}
                  {s.countKey && counts[s.countKey] ? (
                    <span className="rb-nav__panel-count">{counts[s.countKey]}</span>
                  ) : null}
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="rb-nav__item" onMouseLeave={() => setOpenPanel(null)}>
          <button
            type="button"
            className={isCasino ? "rb-nav__link rb-nav__link--active" : "rb-nav__link"}
            aria-expanded={openPanel === "casino"}
            aria-haspopup="true"
            onClick={(e) => toggle("casino", e.currentTarget)}
            onMouseEnter={(e) => open("casino", e.currentTarget)}
          >
            Casino
            <span className="rb-nav__caret" aria-hidden="true">
              &#9660;
            </span>
          </button>
          {openPanel === "casino" && (
            <div className="rb-nav__panel" role="menu" style={panelAt}>
              {NAV_CASINO.map((c) => (
                <button
                  key={c.label}
                  type="button"
                  role="menuitem"
                  className="rb-nav__panel-link"
                  onClick={() => navigate("/casinoGames", { state: { list: c.list } })}
                >
                  <i className={"fa " + c.icon} aria-hidden="true" />
                  {c.label}
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="rb-nav__item" onMouseLeave={() => setOpenPanel(null)}>
          <button
            type="button"
            className={isGames ? "rb-nav__link rb-nav__link--active" : "rb-nav__link"}
            aria-expanded={openPanel === "games"}
            aria-haspopup="true"
            onClick={(e) => toggle("games", e.currentTarget)}
            onMouseEnter={(e) => open("games", e.currentTarget)}
          >
            Games
            <span className="rb-nav__caret" aria-hidden="true">
              &#9660;
            </span>
          </button>
          {openPanel === "games" && (
            <div className="rb-nav__panel" role="menu" style={panelAt}>
              {NAV_GAMES.map((g) => (
                <button
                  key={g.label}
                  type="button"
                  role="menuitem"
                  className="rb-nav__panel-link"
                  onClick={() =>
                    g.path
                      ? navigate(g.path)
                      : navigate("/casinoGames", { state: { list: g.list } })
                  }
                >
                  <i className={"fa " + g.icon} aria-hidden="true" />
                  {g.label}
                </button>
              ))}
            </div>
          )}
        </div>

        {totalLive > 0 && (
          <button
            type="button"
            className="rb-nav__link"
            onClick={() => navigate("/inplay")}
            aria-label={"In play, " + totalLive + " events live now"}
          >
            <span className="rb-nav__live">LIVE {totalLive}</span>
          </button>
        )}
      </div>
    </nav>
  );
};


export const Header = ({
  isSidebar,
  setSidebar,
  isDesktop,
  refreshHeader,
  show,
  handleClose,
  handleShow,
  changeCasinoTab,
}) => {
  const { themeColors } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const activeOneClickBtn = useRef(null);
  const [active, setactive] = useState(false);
  const [regactive, setregactive] = useState(false);

  const {
    logout,
    userdata,
    isAuthenticated,
    login,
    userBalnc,
    setIsAuthenticated,
  } = useContext(AuthContext);
  const [sidebaar, setsidebaar] = useState(false);
  const [userid, setuserid] = useState({
    nameUser: "",
    userPhone: "",
    // RB(2026-09-09): seeded from localStorage so a reload paints the name
    // immediately, then the GetUserInfo effect below overwrites it with the
    // authoritative value.
    userName: localStorage.getItem("username") || "",
  });
  const [userBal, setUserBal] = useState({ userTotalBal: 0, bonus: 0 });
  const [activeLink, setActiveLink] = useState("reports");
  const [isOneClickBet, setIsOneClickBet] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [liability, setLiability] = useState("0");
  const [toastActive, setToastActive] = useState(false);
  const [toastActive1, setToastActive1] = useState(false);
  const [toastActive2, setToastActive2] = useState(false);
  const [myInviteCode, setInviteCode] = useState();
  const [login_count, setTotalLogin] = useState();
  const isMobile = useIsMobile();
  const [cricket, setCricket] = useState([]);
  const [football, setFootball] = useState([]);
  const [avail, setAvail] = useState([]);
  const [selectedBet, setSelectedBet] = useState(0);
  const [backActive, setbackActive] = useState(0);
  const [layActive, setlayActive] = useState(0);
  const [money, setMoney] = useState(0);
  const [pr, setPr] = useState(0);
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [side, setSide] = useState("");
  const [selectedMatch, setSelectedMatch] = useState("");
  const [selectionid, setSelectionid] = useState();
  const [runner, setRunner] = useState();
  const [competition, setCompetition] = useState();
  const [eventid, setEventid] = useState();
  const [eventname, setEventname] = useState();
  const [userinfo, setUserinfo] = useState();
  // New Live Matches State Start
  const [livematch, setTodayMatches] = useState(0);
  const [footballLiveCount, setFootballLiveCount] = useState(0);
  const [tennisLiveCount, setTennisLiveCount] = useState(0);
  // New Live Matches State End

  const [role, setRole] = useState();
  const [lockedMatch, setLockedMatch] = useState([]);
  const [lockedMatchesLoaded, setLockedMatchesLoaded] = useState(false); // NEW
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);
  // const [liveTennis?.length || 0, setliveTennis?.length || 0] = useState([]);
  // const [liveSoccer?.length || 0, setliveSoccer?.length || 0] = useState([]);
  // const [liveCricket?.length, setliveCricket?.length] = useState([]);
  const [soccer, setSoccer] = useState([]);
  const [tennis, setTennis] = useState([]);
  const [cric, setCric] = useState([]);
  const [socc, setSocc] = useState([]);
  const [profit, setProfit] = useState("");

  const [showLoginModal, setShowLoginModal] = useState(false);
  const [modalPath2, setModalPath2] = useState("");

  const [showCanvas, setShowCanvas] = useState(false);

  const [showP, setShowP] = useState(false);

  const handleCloseP = () => setShowP(false);
  const handleShowP = () => setShowP(true);
  const [sportsAll, setSportsAll] = useState([]);

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);

  async function sendSMS() {
    try {
      const res = await axios.post(`${base_url}/api/send-sms`, {
        to: "7488047445",
        body: "234561 is OTP for Mobile Verification. This is valid for 1 minute.",
      });

      console.log("SMS API Response:", res.data);
      toast.success("SMS sent!");
    } catch (err) {
      console.error(err);
      toast.error("Failed to send SMS");
    }
  }

  // socket start
  useEffect(() => {
    const handleSocketData = async (payload) => {
      const gotResult = payload.data;
      const eventId = gotResult.eventId;
      const phoneNumber = localStorage.getItem("phoneNumber");

      console.log("Received eventId:", eventId);
      console.log("Received phone:", phoneNumber);

      if (eventId) {
        try {
          const res = await axios.get(`${base_url}/api/get_profite_lose`, {
            params: { eventId, phone: phoneNumber },
          });

          // console.log("Received:", res.data);

          const { profit, lose } = res.data;

          if (profit > 0) {
            toast.success(`You Won ${profit}`);
          } else if (lose > 0) {
            toast.error(`You lose ${lose}`);
          }
        } catch (err) {
          console.error(err);
        }
      }
    };

    const handleConnect = () => {
      console.log("✅ Connected to Real-time Updates");
    };

    socket.on("connect", handleConnect);
    socket.on("fancyGameWinEmitSocket", handleSocketData);

    return () => {
      socket.off("connect", handleConnect);
      socket.off("fancyGameWinEmitSocket", handleSocketData);
    };
  }, []);
  // socket end

  useEffect(() => {
    const hasSeenModal = localStorage.getItem("hasSeenLoginModal");

    if (!hasSeenModal) {
      setShowLoginModal(true);
    }
  }, []);

  const fetchModal = async () => {
    try {
      const response = await axios.get(`${base_url}/api/webapi/fetchModal`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = response.data.data.result[0];
      // console.log("Fetched logo data:", data);

      if (data && data.image) {
        setModalPath2(data.image);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    fetchModal();
  }, []);

  const handleCloseModal = () => {
    localStorage.setItem("hasSeenLoginModal", "true");
    setShowLoginModal(false);
  };

  // const { theme, handleThemeChange } = useTheme();
  const [loading, setLoading] = useState(true);
  const [logoPath, setLogoPath] = useState("");

  useEffect(() => {
    const savedLogo = localStorage.getItem("siteLogo");

    if (savedLogo) {
      try {
        const parsed = JSON.parse(savedLogo);
        const oneDay = 24 * 60 * 60 * 1000;

        // Check if cached data is still valid
        if (Date.now() - parsed.timestamp < oneDay) {
          setLogoPath(parsed.path);
          return; // Use cached logo
        } else {
          localStorage.removeItem("siteLogo"); // Expired, remove
        }
      } catch (err) {
        // If JSON parsing fails, clear corrupted cache
        localStorage.removeItem("siteLogo");
      }
    }

    // If no valid cache, fetch logo
    showLogo();
  }, []);

  const showLogo = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        base_url + "/api/webapi/fetchLogoAction",
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response?.data?.data?.result?.[0];

      if (data?.logo_image) {
        setLogoPath(data.logo_image);
        localStorage.setItem(
          "siteLogo",
          JSON.stringify({
            path: data.logo_image,
            timestamp: Date.now(),
          })
        );
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClicktoast = () => {
    if (!toastActive) {
      setToastActive(true);
      toast.success("Coming soon", {
        onClose: () => setToastActive(false),
      });
    }
  };

  const handleClicktoast1 = () => {
    if (!toastActive1) {
      setToastActive1(true);
      toast.success("Coming soon", {
        onClose: () => setToastActive1(false), // 🔁 Re-enable after toast closes
      });
    }
  };

  const handleClicktoast2 = () => {
    if (!toastActive2) {
      setToastActive2(true);
      toast.success("Coming soon", {
        onClose: () => setToastActive2(false), // 🔁 Re-enable after toast closes
      });
    }
  };

  const [hovered, setHovered] = useState(null);

  const handleMouseEnter = (key) => setHovered(key);
  const handleMouseLeave = () => setHovered(null);

  const isHovered = (key) => hovered === key;

  const isSmallScreen = window.innerWidth <= 767;
  const topValue = location.pathname === "/" ? 98 : isSmallScreen ? 0 : 79;
  // The header is the only thing polling the three match endpoints, so it
  // publishes what it has rather than every other consumer opening its own
  // poll. The side menu reads these.
  useEffect(() => {
    setLiveCounts({
      cricket: Number(livematch) || 0,
      football: Number(footballLiveCount) || 0,
      tennis: Number(tennisLiveCount) || 0,
    });
  }, [livematch, footballLiveCount, tennisLiveCount]);

  const styles = {
    radheExchange0: {
      // Was "Roboto Condensed" inline, which beats the stylesheet and left
      // the top strip in a different face from the rest of the site.
      fontFamily: "var(--rb-font)",
      position: "sticky",
      top: 0,
      zIndex: 99,
      width: "100%",
    },
    radheExchange: {
      // Was "Roboto Condensed" inline, which beats the stylesheet and left
      // the top strip in a different face from the rest of the site.
      fontFamily: "var(--rb-font)",
      position: "sticky",
      top: 0,
      zIndex: 99,
      width: isSmallScreen ? "48%" : "",
    },
    radheExchange2: {
      display: isSmallScreen ? "block" : "block",
      // Was "Roboto Condensed" inline, which beats the stylesheet and left
      // the top strip in a different face from the rest of the site.
      fontFamily: "var(--rb-font)",
      position: "sticky",
      top: 0,
      zIndex: 99,
      width: "100%",
    },
    marqueeDiv: {
      // backgroundColor: "var(--dark-theme-dark-blue-variant)",
      backgroundColor: "var(--rb-surface)",
      width: isSmallScreen ? "103.8%" : "100.5%",
    },
    headerContainer: {
      backgroundImage: "var(--dark-theme-bg)",
      backgroundColor: "var(--rb-surface)",
      color: "white",
    },
    liveBadge: {
      position: "absolute",
      display: "flex",
      fontSize: "8px",
      backgroundColor: "var(--dark-theme-color-navbar)",
      // backgroundColor: "#7DC4FF",
      color: "var(--dark-theme-demoaccount)",
      paddingLeft: "2px",
      borderRadius: "3px",
      marginLeft: "5px",
      top: isSmallScreen ? "3px" : "-4px",
      left: isSmallScreen ? "16px" : "",
    },
    aviator: {
      position: "absolute",
      display: "flex",
      fontSize: "8px",
      top: isSmallScreen ? "3px" : "-3px",
      left: isSmallScreen ? "16px" : "",
      height: "20px",
    },
    liveCount: {
      display: "inline-block",
      backgroundColor: "var(--dark-theme-demoaccount)",
      color: "var(--dark-theme-color-navbar)",
      // borderRadius: '50%',
      width: "12px",
      height: "12px",
      borderTopRightRadius: "3px",
      borderBottomRightRadius: "3px",
      fontSize: "9px",
      fontWeight: "bold",
      paddingBottom: "0px !important",
      textAlign: "center",
      lineHeight: "14px",
      marginLeft: "2px",
    },
    navItemsLanding: {
      position: isSmallScreen ? "relative" : "",
      padding: isSmallScreen ? "4px" : "14px 7px",
      top: isSmallScreen ? "0px" : "0px",
      height: isSmallScreen ? "" : "40px",
    },
    navLanding: {
      position: "sticky",
      top: topValue,
      width: isSmallScreen ? "100%" : "100%",
      height: isSmallScreen ? "140px" : "40px",
    },
    demoAccountDiv: {
      position: "relative",
    },
    demoAccountBtn: {
      backgroundColor: "var(--dark-theme-demoaccount)",
      color: "var(--dark-theme-color-navbar)",
      position: "absolute",
      bottom: isSmallScreen ? 47 : 53,
      border: "none",
      right: isSmallScreen ? -40 : -40,
      borderRadius: "4px",
      width: isSmallScreen ? "145px" : "150px",
      paddingTop: isSmallScreen ? "3px" : "7px",
      fontSize: isSmallScreen ? "13px" : "12px",
      fontWeight: "bold",
      // Was "Roboto Condensed" inline, which beats the stylesheet and left
      // the top strip in a different face from the rest of the site.
      fontFamily: "var(--rb-font)",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
    },
    accountInfo: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      // marginRight: "2px",
    },
    login: {
      background: "var(--dark-theme-button-special)",
      width: isSmallScreen ? "57px" : "90px",
      borderRadius: isSmallScreen ? "8px" : "10px",
      fontSize: isSmallScreen ? "9px" : "14px",
      padding: isSmallScreen ? "9px 0px" : "8px 5px",
      border: "1px solid var(--accent)",
      color: "var(--on-accent)",
      fontWeight: "bold",
      boxShadow: "0 2px 4px rgba(255, 255, 255, 0.1)",
    },
    balanceBox: {
      background: "var(--dark-theme-button-special)",
      width: isSmallScreen ? "78px" : "100px",
      borderRadius: "7px",
      fontSize: isSmallScreen ? "12px" : "14px",
      padding: isSmallScreen ? "0px 3px" : "1px 5px",
      border: "1px solid var(--rb-border)",
      color: "#ffffff",
      fontWeight: "500",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    },
    balanceBox1: {
      background: "var(--rb-success)",
      width: isSmallScreen ? "100%" : "100px",
      borderRadius: "7px",
      fontSize: isSmallScreen ? "12px" : "14px",
      padding: isSmallScreen ? "8px 3px" : "1px 5px",
      border: "1px solid var(--rb-border)",
      color: "#fff",
      fontWeight: "500",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    },
    expBox1: {
      background: "var(--rb-danger)",
      marginTop: "2px",
      borderRadius: "7px",
      fontSize: isSmallScreen ? "12px" : "14px",
      width: isSmallScreen ? "100%" : "100px",
      padding: isSmallScreen ? "8px 3px" : "0px 4px",
      border: "1px solid var(--rb-border)",
      color: "#fff",
      fontWeight: "500",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    },
    expBox: {
      background: "var(--dark-theme-button-special)",
      marginTop: "2px",
      borderRadius: "7px",
      fontSize: isSmallScreen ? "12px" : "14px",
      width: isSmallScreen ? "78px" : "100px",
      padding: isSmallScreen ? "0px 3px" : "0px 5px",
      border: "1px solid var(--rb-border)",
      color: "#ffffff",
      fontWeight: "500",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    },
    spanBox: {
      fontSize: isSmallScreen ? "12px" : "14px",
    },
    textNowrapSm: {
      overflowX: "auto",
      display: "flex",
      padding: isSmallScreen ? "0px" : "5px 0px",
      width: isSmallScreen ? "100%" : "85%",
      gap: isSmallScreen ? "13px" : "",
    },
    textNowrap: {
      overflowX: "auto",
      display: "flex",
      // padding: isSmallScreen ? '4px' : '10px 0px',
      width: isSmallScreen ? "50%" : "75%",
      gap: isSmallScreen ? "13px" : "",
     
    },
    dates: {
      fontSize: isSmallScreen ? "11px" : "10px",
      color: "#fff",
    },
    offcanvas_menu: {
      color: "var(--dark-theme-color-sidebar)",
      fontSize: "14px",
      fontWeight: "500",
      cursor: "pointer",
      fontFamily: "Roboto Condensed, sansSerif",
    },
  };

  function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, [breakpoint]);

    return isMobile;
  }

  const handleHamburger = () => {
    setSidebar((prev) => !prev);
    if (isMobile) setsidebaar(false);
  };

  const handleSettings = () => {
    setsidebaar((prev) => !prev);
    if (isMobile) setSidebar(false); // only on mobile
  };

  useEffect(() => {
    if (sidebaar) {
      document.body.style.overflow = "hidden"; // lock background scroll
    } else {
      document.body.style.overflow = ""; // unlock
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [sidebaar]);
  useEffect(() => {
    if (isSidebar && isMobile) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isSidebar]);

  const [rawMatches, setRawMatches] = useState([]);
  const sortMatches = (matches) => {
    return [...matches].sort((a, b) => {

      const aLive = a?.inplay || a?.event?.inPlay || a?.event?.status === "LIVE";
      const bLive = b?.inplay || b?.event?.inPlay || b?.event?.status === "LIVE";

      // 1️⃣ Live matches first
      if (aLive && !bLive) return -1;
      if (!aLive && bLive) return 1;

      // 2️⃣ Then by increasing start time
      const timeA = new Date(a?.event?.openDate).getTime();
      const timeB = new Date(b?.event?.openDate).getTime();

      return timeA - timeB;
    });
  };

  const handleClick = (linkName) => {
    setActiveLink((prev) => (prev === linkName ? null : linkName));
  };
  const handleOneClickBtn = (e) => {
    e.preventDefault();
    document
      .querySelector(".active_one_click")
      ?.classList.remove("active_one_click");
    if (activeOneClickBtn.current) {
      activeOneClickBtn.current.classList.remove("active_one_click");
    }
    e.target.classList.add("active_one_click");
    activeOneClickBtn.current = e.target;
  };

  const [loginFormData, setLoginFormData] = useState({
    phoneNumber: "9999999999",
    password: "123456",
    iAcceptAll: true,
  });

  const submitlogin = (e) => {
    e.preventDefault();
    //  if (!loginFormData.phoneNumber || !loginFormData.password) {
    //    ToastMessage(0, "All fields are required!");
    //    return;
    //  }
    //  if (!/^\d{10}$/.test(loginFormData.phoneNumber)) {
    //   ToastMessage(0, "PhoneNumber should be 10 digits");
    //   return;
    // }
    //  if(!loginFormData.iAcceptAll){
    //    ToastMessage(0,"Please Accept The Terms And Conditions");
    //    return;
    //  }
    let { iAcceptAll, ...data } = loginFormData;
    login(data, function (res) {
      if (res.status) {
        setIsAuthenticated(true);
        ToastMessage(1, res.message);

        setactive(false);
        setregactive(false);
        navigate("/");
      } else {
        ToastMessage(0, res.message);
      }
    });
  };

  // console.log("locked match" , lockedMatch)

  const getMinutesSinceMidnight = (date) => {
    return date.getUTCHours() * 60 + date.getUTCMinutes(); // Ensures UTC time handling
  };

  const compareWithToday = (openDate) => {
    const now = new Date();

    const today = formatDate(now);

    const tomorrow = formatDate(new Date(now.getTime() + 24 * 60 * 60 * 1000));

    const eventDateObj = new Date(openDate);

    const eventDateFormatted = formatDate(eventDateObj);

    return eventDateFormatted === today || eventDateFormatted === tomorrow;
  };

  // New Code Match Live Start
  const matchData = async () => {
    setLoading(true);

    try {
      const response = await sharedGet(base_url + "/api/webapi/matchapi");

      const data = response?.data?.result?.data || [];
      const allOpenDates = data.map(dta => dta?.event?.openDate);

      const allData = [];

      data.forEach((dta) => {
        if (compareWithToday(dta?.event?.openDate, allOpenDates)) {
          allData.push(dta);
        }
      });

      const now = new Date();

      const liveMatches = allData.filter((dta, index) => {
        if (!dta?.event?.openDate) return false;

        const matchTime = new Date(dta.event.openDate);

        // console.log("MATCH TIME 👉", matchTime);

        return matchTime <= now;
      });

      // console.log("LIVE MATCHES ✅", liveMatches);

      setTodayMatches(liveMatches.length);

    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };
  // New Code Match Live End

  // ✅ STEP 1B: footballData - setRawMatches instead of setCricket
  // New Code Scoeer Start
  const footballData = async () => {
    setLoading(true);

    try {
      const response = await sharedGet(base_url + "/api/webapi/footballapi", {
        headers: { "Content-Type": "application/json" },
      });

      // console.log("Football API Response 👉", response?.data);

      const data = response?.data?.result?.data || [];

      const now = new Date(); // ✅ current time

      const liveFootball = data.filter((dta, index) => {
        if (!dta?.event?.openDate) return false;

        const matchTime = new Date(dta.event.openDate);

        // console.log(`FOOTBALL MATCH ${index}`);
        // console.log("MATCH TIME 👉", matchTime);
        // console.log("CURRENT TIME 👉", now);

        // ✅ LIVE condition (2 hours window)
        return (
          matchTime <= now &&
          now <= new Date(matchTime.getTime() + 2 * 60 * 60 * 1000)
        );
      });

      // console.log("LIVE FOOTBALL MATCHES ✅", liveFootball);

      // ✅ count set karo
      setFootballLiveCount(liveFootball.length);

    } catch (error) {
      console.error("Football API Error:", error);
    } finally {
      setLoading(false);
    }
  };
  // New Code Scoeer End

  // ✅ STEP 1C: tennisData - setRawMatches instead of setCricket
  // New Tennis Live Start

  const tennisData = async () => {
    setLoading(true);

    try {
      const response = await sharedGet(base_url + "/api/webapi/tennisapi", {
        headers: { "Content-Type": "application/json" },
      });
      // console.log("Tennis API Response 👉", response?.data);
      const data = response?.data?.result?.data || [];
      const allOpenDates = data.map(dta => dta?.event?.openDate);
      const allData = [];
      data.forEach((dta) => {
        if (compareWithToday(dta?.event?.openDate, allOpenDates)) {
          allData.push(dta);
        }
      });
      setRawMatches(allData);
      const now = new Date();
      const liveTennis = allData.filter((dta, index) => {
        if (!dta?.event?.openDate) return false;

        const matchTime = new Date(dta.event.openDate);
        return (
          matchTime <= now
        );
      });

      // console.log("LIVE TENNIS MATCHES ✅", liveTennis);

      // ✅ count set karo
      // setTennisLiveCount(liveTennis.length);

    } catch (error) {
      console.error("Tennis API Error:", error);
    } finally {
      setLoading(false);
    }
  };
  // New Tennis Live End

  useEffect(() => {
    const getMarkets = async () => {

      if (rawMatches.length === 0) return;

      try {

        const eventIds = rawMatches.map(item => item?.event?.id);

        const response = await sharedPost(
          `${base_url}/game/kheloyaar/getMarkets`,
          { eventIds }
        );

        const markets = response.data.data || [];

        const allOpenDates = markets.map(dta => dta?.event?.openDate);
        const allData = [];
        markets.forEach((dta) => {
          if (compareWithToday(dta?.event?.openDate, allOpenDates)) {
            allData.push(dta);
          }
        });

        const now = new Date();
        const liveTennis = allData.filter((dta, index) => {
          if (!dta?.event?.openDate) return false;

          const matchTime = new Date(dta.event.openDate);
          return (
            matchTime <= now
          );
        });

        setTennisLiveCount(liveTennis.length);
        // console.log(liveTennis, 'HeaderLiveTenis')

        // 🔥 SORT MATCHES
        const sortedMarkets = sortMatches(markets);
        // setCricket(sortedMarkets);



      } catch (err) {
        console.error("Markets Error:", err);
      }

    };

    getMarkets();

  }, [rawMatches]);

  // const oddsData1 = async (req, res) => {
  //   // console.log("Data is working ");
  //   let marketid = [];

  //   // console.log("Cricket dats in the odds are ", cricket);

  //   try {
  //     for (let item of cricket) {
  //       // console.log("items", item);
  //       marketid.push(item.marketId);
  //     }
  //     // console.log(marketid);

  //     const response = await axios.post(
  //       base_url + `/api/webapi/market/wholeMarket`,
  //       marketid,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     console.log('marketid', JSON.parse(response.data));
  //     const result = JSON.parse(response.data);

  //     setCric(result);

  //     console.log("cric", cric);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // const oddsData2 = async (req, res) => {
  //   let marketid = [];

  //   try {
  //     for (let item of soccer) {
  //       marketid.push(item.marketId);
  //     }
  //     // console.log(marketid);

  //     const response = await axios.post(
  //       base_url + `/api/webapi/market/wholeMarket`,
  //       marketid,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     // console.log('marketid',JSON.parse(response.data));
  //     const result = JSON.parse(response.data);
  //     setSocc(result);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // const oddsData3 = async (req, res) => {
  //   let marketid = [];

  //   try {
  //     for (let item of tennis) {
  //       marketid.push(item.marketId);
  //     }
  //     // console.log(marketid);

  //     const response = await axios.post(
  //       base_url + `/api/webapi/market/wholeMarket`,
  //       marketid,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     // console.log('marketid',JSON.parse(response.data));
  //     const result = JSON.parse(response.data);
  //     setAvail(result);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // const odds = async () => {
  //   await oddsData1();
  //   await oddsData2();
  //   await oddsData3();
  // };

  useEffect(() => {
    const fetchAll = async () => {
      await Promise.all([matchData(), footballData(), tennisData()]);
    };
    fetchAll();
  }, []);

  // useEffect(() => {
  //   if (cricket.length > 0 && soccer.length > 0 && tennis.length > 0) {
  //     odds();
  //   }
  // }, [cricket, soccer, tennis]);

  // console.log(cricket,soccer,tennis,"jdfnenfj");
  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      // Start closed and let the visitor open it. Forcing it open
      // above 991px put a fixed panel over the page content.
      setSidebar(false);
    };

    // handleResize();
    // Live-odds fetching lives in the effect above (Promise.all).
    // Calling it here too made every mount hit matchapi, footballapi
    // and tennisapi twice.
  }, []);

  const allowedPaths = [
    "/home",
    "/cricketBet",
    "/sportall",
    "/cricketreal",
    "/footballreal",
    "/tennisreal",
    "/inplay",
  ];

  //  handle bonus
  const handleClaimBonus = async () => {
    try {
      if (userBal.bonus === 0) {
        return;
      }
      // The amount and the account are decided server-side from this session's
      // token. Do not send a balance figure -- the old endpoint wrote whatever
      // number the body carried, to whatever phone the body named.
      const res = await axios.post(
        `${base_url}/api/webapi/bonus/claim`,
        {},
        {
          withCredentials: true,
          headers: {
            Accept: "application/json",
          },
        }
      );

      if (res?.data?.success) {
        setRefresh(!refresh);
        ToastMessage(1, res.data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSubmit = async () => {
    const token = localStorage.getItem("game_token");
    try {
      const response = await axios.post(
        base_url + "/api/webapi/casinoLobby",
        { token },
        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
          },
        }
      );

      // console.log('lobby',response);
      if (response?.data.success) {
        window.location.href = response?.data.url;
      } else {
        toast.error(response?.data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // The header used to look up Aviator's and Ludo's game ids from the
  // provider on every page (two particularGame requests per page view) and
  // store them in state nothing read. Removed.

  const openGameById = async (gameId) => {
    // The id comes from the provider feed, which itself needs a signed-in game
    // token. Signed out it never resolves, and this was still called with
    // undefined -- firing a request that could only fail.
    if (!gameId) {
      toast.error("Please Login to Play.");
      setactive(true);
      return;
    }

    try {
      const token = localStorage.getItem("game_token");
      const response = await axios.post(
        base_url + "/api/gamelaunch/url",
        { token, gameId },
        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
          },
        }
      );

      // console.log('url response',response);
      if (response?.data.success) {
        const url = response?.data.url;
        window.location.href = url;
      } else {
        toast.error("Please Login to Play.");
        setactive(true);
      }
    } catch (err) {
      // /api/gamelaunch/url answers 401 when there is no auth, and axios
      // rejects on any non-2xx -- so a signed-out click lands here, not in the
      // else above. This used to console.log and show the user nothing at all,
      // which is why the button appeared dead.
      console.log(err);
      if (err?.response?.status === 401 || err?.response?.status === 403) {
        toast.error("Please Login to Play.");
        setactive(true);
      } else {
        toast.error("Could not open the game. Please try again.");
      }
    }
  };

  // useEffect(() => {
  //   if (!isAuthenticated) return;

  //   const cachedUser = localStorage.getItem("userDataCache");

  //   if (cachedUser) {
  //     try {
  //       const parsed = JSON.parse(cachedUser);
  //       const expiryTime = 50 * 60 * 1000; // 5 minutes

  //       if (Date.now() - parsed.timestamp < expiryTime) {
  //         // Use cached data
  //         const data = parsed.data;
  //         setUserBal({ userTotalBal: data.money_user, bonus: data.bonus_money });
  //         setuserid({ nameUser: data.name_user, userPhone: data.phone_user, userName: data.username });
  //         return;
  //       } else {
  //         // Cache expired
  //         localStorage.removeItem("userDataCache");
  //       }
  //     } catch (err) {
  //       localStorage.removeItem("userDataCache"); // corrupted cache
  //     }
  //   }

  //   // Fetch fresh user data if no cache or expired
  //   userdata(function (res) {
  //     if (res?.status) {
  //       const data = res.data;

  //       // Set state
  //       setUserBal({ userTotalBal: data.money_user, bonus: data.bonus_money });
  //       setuserid({ nameUser: data.name_user, userPhone: data.phone_user, userName: data.username });

  //       // Store in cache
  //       localStorage.setItem("userDataCache", JSON.stringify({
  //         data,
  //         timestamp: Date.now()
  //       }));
  //     }
  //   });
  // }, [userdata, refreshHeader, isAuthenticated]);

  useEffect(() => {
    const fetchUserBalance = async () => {
      try {
        const response = await axios.post(
          `${base_url}/api/webapi/GetUserData`,
          {}, // body (empty since backend doesn’t expect anything)
          { withCredentials: true }
        );
        console.log("✅ Response", response.data.userinfo);
        setUserinfo(response.data.userinfo);
      } catch (error) {
        if (error.response) {
          console.error("❌ Error response:", error.response.data);
        } else {
          console.error("❌ Error:", error.message);
        }
      }
    };
    // fetchUserBalance();
  }, []);
  useEffect(() => {
    if (isAuthenticated) {
      userdata(function (res) {
        if (res?.status) {
          let data = res.data;
          // console.log(data, "datatat");

          setRole(data.username);

          setUserBal({
            userTotalBal: data.money_user,
            bonus: data.bonus_money || 0,
          });
          setInviteCode(data.code);
          setTotalLogin(data.login_count);
          setuserid({
            nameUser: data.name_user,
            userPhone: data.phone_user,
            userName: data.username,
          });
        }
      });
    }
    // RB(2026-09-08): isAuthenticated MUST stay in the deps. This effect reads it,
    // but with only [refreshHeader] it ran once on mount -- before the auth check
    // had resolved -- took the false branch, and never re-ran when auth completed.
    // userBal stayed at its initial 0 until a hard refresh remounted the component
    // with auth already true: the "balance shows 0 until you refresh" report.
  }, [refreshHeader, isAuthenticated]);

  // The liability poll below is set up once on mount; it reads the current
  // login state through this ref so a guest never polls it.
  const isAuthedRef = useRef(isAuthenticated);
  useEffect(() => {
    isAuthedRef.current = isAuthenticated;
  }, [isAuthenticated]);

  useEffect(() => {
    const LiabilityBalance = async () => {
      try {
        const response = await axios.get(`${base_url}/get/liability`, {
          withCredentials: true,
          headers: { "Content-Type": "application/json" },
        });

        // console.log(response?.data?.data?.totalLiability, "response?.data?.data?.totalLiability");

        if (response?.data?.data?.totalLiability) {
          setLiability(response?.data?.data?.totalLiability);
          // console.log(response?.data?.data?.totalLiability,"cefnenff");
        } else {
          setLiability("0");
        }
      } catch (error) {
        setLiability("0");
      }
    };

    // Call immediately on mount
    // LiabilityBalance();

    // Set up interval. /get/liability is behind the player guard, so a
    // guest's page used to collect a 401 from it every five seconds (#10).
    const interval = setInterval(() => {
      if (isAuthedRef.current) LiabilityBalance();
    }, 5000); // 5 seconds

    // Clean up interval on unmount
    return () => clearInterval(interval);
  }, []);

  // console.log('ludo',ludo);

  // Add CSS to handle responsive design
  const addResponsiveCSS = () => {
    const css = `
    @media (max-width: 768px) {
      .betting-navbar .navbar-nav {
        flex-direction: column !important;
      }
      
      .account-info {
        justify-content: center !important;
        margin-bottom: 6px !important;
      }
      
      .header-container .row {
        flex-direction: row !important;
      }
      
      .header-container .col-md-4 {
        text-align: center !important;
      }
        
    }
  `;

    const styleElement = document.createElement("style");
    styleElement.innerHTML = css;
    document.head.appendChild(styleElement);

    return () => {
      document.head.removeChild(styleElement);
    };
  };

  React.useEffect(() => {
    // Add responsive styles when component mounts
    const cleanup = addResponsiveCSS();

    // Remove styles when component unmounts
    return cleanup;
  }, []);

  const isHomePage = location.pathname === "/";

  // const [show, setShow] = useState(false);

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  useEffect(() => {
    if (sidebaar) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [sidebaar]);

  // current date and time
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formattedDate = currentTime.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  const formattedTime = currentTime.toLocaleTimeString("en-GB");


  // 2️⃣ When cricket is updated → fetch odds
  // useEffect(() => {
  //   const oddsData = async () => {

  //     if (!cricket || cricket.length === 0) return;

  //     try {

  //       // collect all marketIds
  //       const marketIds = cricket
  //         .map((item) => item?.marketId)
  //         .filter(Boolean);

  //       if (marketIds.length === 0) return;

  //       const response = await axios.post(
  //         `${base_url}/api/webapi/market/wholeMarket`,
  //         { marketIds }, // ✅ correct payload
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           timeout: 10000,
  //         }
  //       );

  //       const oddsData = response?.data?.data || [];

  //       console.log("Odds Data:", oddsData);

  //       setAvail(oddsData);

  //     } catch (err) {
  //       console.error("Error fetching odds data:", err);
  //     }

  //   };

  //   oddsData();

  // }, [cricket]);

  // console.log(cric,socc,avail,"nejnfe")
  const isLiveMatch = (openDate) => {
    if (!openDate) return false;
    return new Date() >= new Date(openDate);
  };

  const hasOdds = (market) => {
    return (
      market &&
      market.runners?.some(
        (runner) =>
          runner?.ex?.availableToBack?.length > 0 ||
          runner?.ex?.availableToLay?.length > 0
      )
    );
  };

  const liveCricket = cricket?.filter((item) => {
    const market = avail.find((m) => m.marketId === item.marketId);

    return isLiveMatch(item?.event?.openDate) && hasOdds(market);
  });


  // const liveCricketCount = liveCricket?.length || 0;

  const liveSoccer = (soccer || []).filter((item) => {
    const market = avail?.find((m) => m.marketId === item.marketId);

    return checkOpenDate(item?.event?.openDate) === "InPlay" && market && hasOdds(market);
  });

  const liveTennis = (tennis || []).filter((item) => {
    const market = avail?.find((m) => m.marketId === item.marketId);

    return checkOpenDate(item?.event?.openDate) === "InPlay" && market && hasOdds(market);
  });

  const liveCricketCount = liveCricket.length;
  const liveSoccerCount = liveSoccer.length;
  const liveTennisCount = liveTennis.length;

  // console.log("Live liveMatches:", liveCricketCount, liveSoccerCount, liveTennisCount);

  // console.log(liveCricket?.length ,liveSoccer?.length ,liveTennis?.length ,"kndnejfn")
  const matchCount = {
    Cricket: liveCricket?.length || 0,
    Soccer: liveSoccer?.length || 0,
    Tennis: liveTennis?.length || 0,

    Horse: 0,
    GreyHound: 0,
  };
  // console.log(matchCount,"hehhcbh")

  // console.log(matchCount,"kndnejfn")





  const profitLoss = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + "/api/webapi/profitLosss", {
        withCredentials: true,
      });

      // console.log(response, "responseresponse");

      const sportData = response?.data?.sportData || [];
      const casinoData = response?.data?.casinoData || [];
      const fancyData = response?.data?.fancyData || [];

      let totalWon = 0;
      let totalLost = 0;
      let totalPending = 0;

      const toNum = (v) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
      };
      const norm = (s) => (s ?? "").toString().trim().toLowerCase();

      // ----- Sports -----
      sportData.forEach((item) => {
        const betAmount = toNum(item.betAmount);
        const profit = toNum(item.profit);
        const status = item.status;

        if (status === 1) {
          totalWon += profit;
        } else if (status === 2) {
          totalLost += betAmount;
        } else if (status === 0) {
          totalPending += betAmount;
        }
      });

      // ----- Fancy Bets -----
      fancyData.forEach((item) => {
        const betAmount = toNum(item.betAmount);
        const profit = toNum(item.profit);
        const status = item.status;

        if (status === 1) {
          totalWon += profit;
        } else if (status === 2) {
          totalLost += betAmount;
        } else if (status === 0) {
          totalPending += betAmount;
        }
      });

      // ----- Casino -----
      casinoData.forEach((item) => {
        const amount = toNum(item.amount);
        const profit = toNum(item.profit);
        const status = norm(item.status);

        if (status === "win") {
          totalWon += profit !== 0 ? profit : amount;
        } else if (
          status === "loss" ||
          status === "lost" ||
          status === "lose"
        ) {
          totalLost += amount || Math.abs(profit);
        } else if (status === "pending" || status === "processing") {
          totalPending += amount || Math.abs(profit);
        }
      });

      const netProfit = totalWon - totalLost;

      const round2 = (n) => Number(n.toFixed(2));
      const uiNet = round2(netProfit);

      setProfit(uiNet >= 0 ? `+${uiNet}` : `${uiNet}`);

      // console.log({
      //   totalWon: round2(totalWon),
      //   totalLost: round2(totalLost),
      //   totalPending: round2(totalPending),
      //   netProfit: round2(netProfit),
      // });
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Both of these read the player's own bets and answer 401 to a guest,
  // which every logged-out visit did twice (#10). Load them once a player
  // is signed in instead of on mount.
  useEffect(() => {
    if (isAuthenticated) profitLoss();
  }, [isAuthenticated]);

  const sportBetAll = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + "/api/webapi/sportsBet", {
        withCredentials: true,
        headers: {
          "content-type": "application/json",
        },
      });
      const sportdata = response.data.sportsBets;
      const fancydata = response.data.fancyBets;

      const combinedData = [...sportdata, ...fancydata];

      setSportsAll(combinedData);
      // console.log(data, 'responseeeee')
    } catch (error) {
      console.error("API ERROR", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated) sportBetAll();
  }, [isAuthenticated]);

  return (
    <>
      <style>{`
  .navItems-landingSm[_ngcontent-jrx-c95]:hover {
    color: red;
    background-color: transparent !important;
  }
  .offcanvas-header .btn-close {

    height: 25px;
    width: 20px;
    opacity: var(--bs-btn-close-focus-opacity);
}
    .btn-close:focus{
        box-shadow: none;
    }
  
  .user_tabs p{
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 8px;
        padding-right: 0px;
        color: 'var(--dark-theme-color-navbar)';
  }
  .user_tabs p:hover {
    background-color: 'var(--dark-theme-time-remaining)';
    cursor: pointer;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .rules {
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 8px;
        padding-right: 0px;
  }
  .btn-close{
    position: relative;
    top: 0px;
    z-index: 99;
  }
    .modal-dialog{
      justify-content: start !important;
      margin: 15px 25px !important;
      overflow-x: visible !important;
    }
    .modal .modal-dialog .modal-content{
        margin-top: 0px !important;
        width: 90vw !important;
        height: auto !important;
    }
        .back-row {
  background-color: var(--dark-theme-data-box) !important;
  color: black !important;
}

.lay-row {
  background-color: #faa9ba !important;
  color: black !important;
}
.no-hover tbody tr:hover {
  background-color: inherit !important;
}


  .modal-header{
      padding: 0px 15px;
  }
  body.dark-theme .modal-content{
    background-color: white;
  }
  .borderedd{
    border: 1px solid white !important;
  }
         
  @media (max-width: 768px) {
    .navItems-landingSm[_ngcontent-jrx-c95]:hover {
      color: red !important;
      background-color: transparent !important;
    }
    .modal-dialog{
      margin: 15px 0px !important;
    }
    .navItems-landing[_ngcontent-jrx-c95] span[_ngcontent-jrx-c95]:hover {
      color: red !important;
    }
    .modal-header{
      width: 100% !important;
    }
      .modal-dialog{
        overflow: visible !important;
      }
.back-row {
  background-color: var(--dark-theme-data-box) !important;
  color: black !important;
}

.lay-row {
  background-color: #faa9ba !important;
  color: black !important;
}
.no-hover tbody tr:hover {
  background-color: inherit !important;
}
  .modal-content .modal-body{
    width: 100%;
  }

    .modal .modal-dialog .modal-content{
      justify-content: start !important;
      overflow-x: auto !important;
    }
  }
`}</style>
      {
        <LoginReg
          active={active}
          setactive={setactive}
          regactive={regactive}
          setregactive={setregactive}
        />
      }
      {/* <LoginModal show={showLoginModal} handleClose={handleCloseModal}  modalpathImage={modalPath2} /> */}

      {!isAuthenticated && (
        <div style={styles.radheExchange0}>
          {/* Announcement, brand row, nav: about 108px of chrome in total.
              It used to be a marquee row, a 60px logo row, a login row and
              a nav row -- roughly 190px before any product appeared. */}
          <RbAnnounce clock={formattedDate + " " + formattedTime} />

          <div className="rb-topbar">
            <div className="rb-topbar__inner">
              <button
                type="button"
                className="rb-topbar__menu"
                data-rb-menu-trigger=""
                onClick={handleHamburger}
                aria-label={isSidebar ? "Close menu" : "Open menu"}
                aria-expanded={isSidebar}
              >
                <i
                  className={isSidebar ? "fa fa-times" : "fa fa-bars"}
                  aria-hidden="true"
                />
              </button>

              <Link to="/" className="rb-topbar__logo" aria-label="Rajbet65 home">
                <img src="/assets/images/rajbet65-logo.png" alt="Rajbet65" />
              </Link>

              <span className="rb-topbar__spacer" />

              <RbSearch />

              <div className="rb-topbar__actions">
                {/* Sign up is the primary action, so it carries the gold
                    fill; Login is the outlined secondary. Both used to be
                    identical gold buttons, which gave the user no steer. */}
                <button
                  type="button"
                  className="rb-btn rb-btn--secondary rb-btn--sm"
                  onClick={() => setactive(true)}
                >
                  Log in
                </button>
                <button
                  type="button"
                  className="rb-btn rb-btn--primary rb-btn--sm"
                  onClick={() => setregactive(true)}
                >
                  Sign up
                </button>
              </div>
            </div>
          </div>

          <RbNav liveCounts={{ cricket: livematch, football: footballLiveCount, tennis: tennisLiveCount }} />
        </div>
      )}

      {isAuthenticated && (
        <div style={styles.radheExchange2}>
          <RbAnnounce clock={formattedDate + " " + formattedTime} />
          {/* Header section */}
          <div style={styles.headerContainer} className="header-container">
            <div className="container-fluid px-0 py-xl-2">
              <div className="justify-content-between d-flex rb-authbar">
                <div className=" mb-0 py-lg-1 py-0 px-lg-0 px-3">
                  <div
                    _ngcontent-jrx-c79=""
                    className="sidebar-header h-100"
                    style={{
                      display: "flex",
                      padding: isSmallScreen ? "0px" : "0px",
                    }}
                  >
                    <div _ngcontent-mkq-c111="" className="site_menu">
                      <div
                        _ngcontent-mkq-c111=""
                        className="header_menu_bar mt-4"
                      >
                        {/* The signed-in menu button. It carried d-md-none, so
                            from 768px up (tablets, laptops) it was invisible,
                            and pages passing isDesktop dropped it entirely --
                            a logged-in player on a laptop had no way to open
                            the menu. Shown at every width now, and it turns
                            into a close button while the menu is open, like
                            the signed-out bar. */}
                        <Link
                          _ngcontent-mkq-c111=""
                          data-target="nav-mobile"
                          className="sidenav-trigger"
                          data-rb-menu-trigger=""
                          onClick={handleHamburger}
                          aria-label={isSidebar ? "Close menu" : "Open menu"}
                          aria-expanded={!!isSidebar}
                        >
                          <i
                            className={isSidebar ? "fa fa-times d-block" : "fa fa-bars d-block"}
                            aria-hidden="true"
                            style={{
                              fontSize: "23px",
                              fontWeight: "bold",
                              color: "white",
                            }}
                          ></i>
                        </Link>
                      </div>
                    </div>
                    <Link
                      to="/"
                      aria-label="Rajbet65 home"
                      className="d-flex align-items-center ms-2 ms-lg-0 my-auto logo-style"
                      style={{ textDecoration: "none", width: isSmallScreen ? "141px" : "195px", height: "60px" }}
                    >
                      <img
                        className="img-fluid top_dark logo-img"
                        style={{ width: "100%", height: "70px", objectFit: "contain" }}
                        // src={logoPath ? `${base_url}${logoPath}` : "/assets/images/radhexc_logo2.svg"}
                        // src="https://images.staticcontent.io/rde/uimg/r77/brand_logo.svg"
                        src="/assets/images/rajbet65-logo.png"
                        alt="Rajbet65"
                      />
                    </Link>
                  </div>
                </div>
                <div className="d-none d-lg-flex align-items-center px-3">
                  <RbSearch />
                </div>

                {/* The user-ID chip that sat here floated over the header on
                    every page (on phones, on top of the logo row). The name
                    now opens the menu instead: it heads the side drawer, with
                    the balance and Deposit / Withdraw (Sidebar.js). */}

                <div className=" px-xl-3 px-1 mb-0 py-1">
                  <div style={styles.accountInfo} className="account-info">
                    <div className="d-flex gap-1">
                      {role !== "demo" && (
                        <>
                          <div
                            className=" flex-column"
                            style={{ display: isSmallScreen ? "none" : "flex" }}
                          >
                            <Button
                              className="ms-auto text-center"
                              variant="primary"
                              onClick={() => navigate("/deposit")}
                              style={styles.balanceBox1}
                            >
                              <span>
                                <i
                                  className="fa fa-money"
                                  aria-hidden="true"
                                ></i>{" "}
                              </span>
                              <span style={styles.spanBox}>Deposit</span>
                            </Button>
                            <Button
                              className="ms-auto text-center"
                              variant="primary"
                              onClick={() => navigate("/withdraw")}
                              style={styles.expBox1}
                            >
                              <span style={styles.spanBox}>
                                <i
                                  className="fa fa-money"
                                  aria-hidden="true"
                                ></i>{" "}
                                Withdrawal
                              </span>
                            </Button>
                          </div>
                        </>
                      )}
                      <div className="d-flex flex-column">
                        {" "}
                        <Button
                          className="ms-auto text-center"
                          variant="primary"
                          onClick={handleShow}
                          style={styles.balanceBox}
                        >
                          <span>
                            <img
                              className="img-fluid"
                              style={{ height: "16px" }}
                              src="/assets/images/coin.svg"
                              alt=""
                            />{" "}
                          </span>
                          <span style={styles.spanBox}>
                            {formatINR(userBalnc?.userTotalBal < 0 ? 0 : userBalnc?.userTotalBal)}
                          </span>
                        </Button>
                        <Button
                          className="ms-auto text-center"
                          variant="primary"
                          onClick={handleShow}
                          style={styles.expBox}
                        >
                          <span style={styles.spanBox}>Exp: {liability}</span>
                        </Button>
                      </div>
                    </div>
                    <Offcanvas
                      show={show}
                      onHide={handleClose}
                      placement="end"
                      style={{
                        backgroundColor: "var(--dark-theme-dark-blue-variant)",
                        width: "275px",
                      }}
                    >
                      <Offcanvas.Header closeButton></Offcanvas.Header>

                      <Offcanvas.Body className="text-white py-3">
                        <h6 id="offcanvasRightLabel" style={{ color: "#ffffff" }}>
                          <i
                            className="fa fa-user pr-2 cmenu"
                            style={{
                              color: "var(--report-cate-item-border-clr)",
                            }}
                            aria-hidden="true"
                          ></i>
                          {userid.userName} [ {formatINR(userBal.userTotalBal < 0 ? 0 : userBal.userTotalBal)} ]
                        </h6>

                        <div className="d-flex">
                          <>
                            {/* Trigger Div */}
                            <div
                              className="btn border border-light pe-5 py-2 w-50"
                              style={{
                                backgroundColor:
                                  "var(--dark-theme-time-remaining)",
                                color: "var(--dark-theme-color-navbar)",
                              }}
                              onClick={handleShowP}
                            >
                              <p className="mb-0 text-start">Exposure</p>
                              <p
                                className="mb-0 text-start text-white"
                                style={{ textAlign: "justify" }}
                              >
                                {liability}
                              </p>
                            </div>




                            {/* Popup Modal */}
                            <Modal
                              show={showP}
                              onHide={handleCloseP}
                              size="lg"
                              centered
                              dialogClassName="custom-modal"
                            >
                              <Modal.Header
                                style={{
                                  backgroundColor: "var(--rb-surface-2)",
                                  color: "#fff",
                                }}
                                closeButton
                              >
                                <Modal.Title className="fs-5 py-2">
                                  Unsettled Bets
                                </Modal.Title>
                              </Modal.Header>

                              <Modal.Body>
                                <Table bordered responsive className="no-hover">
                                  <thead>
                                    <tr style={{ backgroundColor: "#ffeb3b" }}>
                                      <th
                                        style={{
                                          backgroundColor: "var(--rb-surface-2)",
                                          color: "var(--rb-text)",
                                          padding: "10px",
                                        }}
                                      >
                                        Competition
                                      </th>
                                      <th
                                        style={{
                                          backgroundColor: "var(--rb-surface-2)",
                                          color: "var(--rb-text)",
                                          padding: "10px",
                                        }}
                                      >
                                        Event
                                      </th>
                                      <th
                                        style={{
                                          backgroundColor: "var(--rb-surface-2)",
                                          color: "var(--rb-text)",
                                          padding: "10px",
                                        }}
                                      >
                                        Market
                                      </th>
                                      <th
                                        style={{
                                          backgroundColor: "var(--rb-surface-2)",
                                          color: "var(--rb-text)",
                                          padding: "10px",
                                        }}
                                      >
                                        Runner
                                      </th>
                                      <th
                                        style={{
                                          backgroundColor: "var(--rb-surface-2)",
                                          color: "var(--rb-text)",
                                          padding: "10px",
                                        }}
                                      >
                                        Side
                                      </th>
                                      <th
                                        style={{
                                          backgroundColor: "var(--rb-surface-2)",
                                          color: "var(--rb-text)",
                                          padding: "10px",
                                        }}
                                      >
                                        Rate
                                      </th>
                                      <th
                                        style={{
                                          backgroundColor: "var(--rb-surface-2)",
                                          color: "var(--rb-text)",
                                          padding: "10px",
                                        }}
                                      >
                                        Amount
                                      </th>
                                      {/* <th
                                        style={{
                                          backgroundColor: "var(--rb-surface-2)",
                                          color: "var(--rb-text)",
                                          padding: "10px",
                                        }}
                                      >
                                        PP
                                      </th> */}
                                      {/* <th style={{ backgroundColor: "var(--rb-surface-2)", color: "#000", padding: "10px" }}>PL</th> */}
                                      <th
                                        style={{
                                          backgroundColor: "var(--rb-surface-2)",
                                          color: "var(--rb-text)",
                                          padding: "10px",
                                        }}
                                      >
                                        Status
                                      </th>
                                      <th
                                        style={{
                                          backgroundColor: "var(--rb-surface-2)",
                                          color: "var(--rb-text)",
                                          padding: "10px",
                                        }}
                                      >
                                        Date
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {sportsAll?.length > 0 &&
                                      sportsAll.map((item, index) => {
                                        return (
                                          <tr
                                            key={index}
                                            className={` ${item?.side === "Back"
                                              ? "back-row"
                                              : "lay-row"
                                              } border border-gray`}
                                          >
                                            <td
                                              className="borderedd"
                                              style={{
                                                backgroundColor:
                                                  item?.side === "Back" ||
                                                    item?.side === "yes"
                                                    ? "var(--dark-theme-data-box)"
                                                    : "#faa9ba",
                                                color: "black",
                                              }}
                                            >
                                              {item?.competitionName}
                                            </td>
                                            <td
                                              className="borderedd"
                                              style={{
                                                backgroundColor:
                                                  item?.side === "Back" ||
                                                    item?.side === "yes"
                                                    ? "var(--dark-theme-data-box)"
                                                    : "#faa9ba",
                                                color: "black",
                                              }}
                                            >
                                              {item?.eventName}
                                            </td>
                                            <td
                                              className="borderedd"
                                              style={{
                                                backgroundColor:
                                                  item?.side === "Back" ||
                                                    item?.side === "yes"
                                                    ? "var(--dark-theme-data-box)"
                                                    : "#faa9ba",
                                                color: "black",
                                              }}
                                            >
                                              {item?.sportname || "cricket"}
                                            </td>
                                            <td
                                              className="borderedd"
                                              style={{
                                                backgroundColor:
                                                  item?.side === "Back" ||
                                                    item?.side === "yes"
                                                    ? "var(--dark-theme-data-box)"
                                                    : "#faa9ba",
                                                color: "black",
                                              }}
                                            >
                                              {item?.runnerName}
                                            </td>
                                            <td
                                              className="borderedd"
                                              style={{
                                                backgroundColor:
                                                  item?.side === "Back" ||
                                                    item?.side === "yes"
                                                    ? "var(--dark-theme-data-box)"
                                                    : "#faa9ba",
                                                color: "black",
                                              }}
                                            >
                                              {item?.side}
                                            </td>
                                            <td
                                              className="borderedd"
                                              style={{
                                                backgroundColor:
                                                  item?.side === "Back" ||
                                                    item?.side === "yes"
                                                    ? "var(--dark-theme-data-box)"
                                                    : "#faa9ba",
                                                color: "black",
                                              }}
                                            >
                                              {item?.betprice}
                                            </td>
                                            <td
                                              className="borderedd"
                                              style={{
                                                backgroundColor:
                                                  item?.side === "Back" ||
                                                    item?.side === "yes"
                                                    ? "var(--dark-theme-data-box)"
                                                    : "#faa9ba",
                                                color: "black",
                                              }}
                                            >
                                              {item?.betAmount}
                                            </td>
                                            {/* <td
                                              className="borderedd"
                                              style={{
                                                color: "green",
                                                backgroundColor:
                                                  item?.side === "Back" ||
                                                  item?.side === "yes"
                                                    ? "var(--dark-theme-data-box)"
                                                    : "#faa9ba",
                                                color: "green",
                                              }}
                                            >
                                              {item?.betAmount}
                                            </td> */}
                                            {/* <td className="borderedd" style={{
                                              color: "#18adc5", backgroundColor: item?.side === "Back" || item?.side === "yes"
                                                ? "var(--dark-theme-data-box)"
                                                : "#faa9ba", color: "#18adc5"
                                            }}>-{item?.profit}</td> */}
                                            <td
                                              className="borderedd"
                                              style={{
                                                backgroundColor:
                                                  item?.side === "Back" ||
                                                    item?.side === "yes"
                                                    ? "var(--dark-theme-data-box)"
                                                    : "#faa9ba",
                                                color: "black",
                                              }}
                                            >
                                              PLACED
                                            </td>
                                            <td
                                              className="borderedd"
                                              style={{
                                                backgroundColor:
                                                  item?.side === "Back" ||
                                                    item?.side === "yes"
                                                    ? "var(--dark-theme-data-box)"
                                                    : "#faa9ba",
                                                color: "black",
                                              }}
                                            >
                                              {item.time}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                  </tbody>
                                </Table>
                              </Modal.Body>

                              <Modal.Footer>
                                <Button
                                  variant="secondary"
                                  onClick={handleCloseP}
                                >
                                  Prev
                                </Button>
                                <Button
                                  style={{
                                    backgroundColor: "var(--rb-surface-2)",
                                    border: "none",
                                    color: "#000",
                                  }}
                                >
                                  Next
                                </Button>
                                <Button variant="danger" onClick={handleCloseP}>
                                  Cancel
                                </Button>
                              </Modal.Footer>
                            </Modal>
                          </>

                          <div
                            className="btn border border-light ms-2 py-2 w-50"
                            style={{
                              backgroundColor:
                                "var(--dark-theme-time-remaining)",
                              paddingRight: "15px",
                              color: "var(--dark-theme-color-navbar)",
                            }}
                          >
                            <p className="mb-0 pe-5 text-start">P&L</p>
                            <p
                              className="mb-0 pe-5 text-start text-white"
                              style={{ textAlign: "justify" }}
                            >
                              {profit}
                            </p>
                          </div>
                        </div>
                        {role !== "demo" && (
                          <div
                            className="mt-2 justify-content-between gap-2"
                            style={{ display: isSmallScreen ? "flex" : "none" }}
                          >
                            <div
                              className=" text-center"
                              variant="primary"
                              onClick={() => navigate("/deposit")}
                              style={styles.balanceBox1}
                            >
                              <span>
                                <i
                                  className="fa fa-money"
                                  aria-hidden="true"
                                ></i>{" "}
                              </span>
                              <span style={styles.spanBox}>Deposit</span>
                            </div>
                            <div
                              className=" text-center"
                              variant="primary"
                              onClick={() => navigate("/withdraw")}
                              style={styles.expBox1}
                            >
                              <span style={styles.spanBox}>
                                <i
                                  className="fa fa-money"
                                  aria-hidden="true"
                                ></i>{" "}
                                Withdrawal
                              </span>
                            </div>
                          </div>

                        )}

                        <p
                          className="mt-3 "
                          style={{
                            ...styles.offcanvas_menu,
                            background:
                              isHovered("rules") &&
                              "var(--dark-theme-time-remaining)",
                            color: isHovered("rules") && "white",
                          }}
                          onClick={() => navigate("/rules")}
                          onMouseEnter={() => handleMouseEnter("rules")}
                          onMouseLeave={handleMouseLeave}
                        >
                          <span>
                            <img
                              src="assets/icons/rules.svg"
                              style={{ height: "19px" }}
                              className="img-fluid me-2"
                              alt=""
                            />
                          </span>
                          Rules
                        </p>

                        {role !== "demo" && (
                          <>
                            <p
                              className="my_bets"
                              style={{
                                ...styles.offcanvas_menu,
                                background:
                                  isHovered("my_bets1") &&
                                  "var(--dark-theme-time-remaining)",
                                color: isHovered("my_bets1") && "white",
                              }}
                              onClick={() =>
                                navigate("/sports_bets", {
                                  state: { activeTab: 0 },
                                })
                              }
                              onMouseEnter={() => handleMouseEnter("my_bets1")}
                              onMouseLeave={handleMouseLeave}
                            >
                              <span _ngcontent-feu-c67="">
                                <img
                                  src="assets/icon/hh3.svg"
                                  style={{ height: "19px" }}
                                  className="img-fluid me-2"
                                  alt=""
                                />
                                Sports Bets
                              </span>
                            </p>
                            <p
                              className="offcanvas_menu"
                              style={{
                                ...styles.offcanvas_menu,
                                background:
                                  isHovered("my_bets2") &&
                                  "var(--dark-theme-time-remaining)",
                                color: isHovered("my_bets2") && "white",
                              }}
                              onClick={() =>
                                navigate("/sports_bets", {
                                  state: { activeTab: 1 },
                                })
                              }
                              onMouseEnter={() => handleMouseEnter("my_bets2")}
                              onMouseLeave={handleMouseLeave}
                            >
                              <span _ngcontent-feu-c67="">
                                <img
                                  src="assets/icons/rules.svg"
                                  style={{ height: "19px" }}
                                  className="img-fluid me-2"
                                  alt=""
                                />
                                Casino Reports
                              </span>
                            </p>

                            {/* <p
                              className="offcanvas_menu"
                              style={{
                                ...styles.offcanvas_menu,
                                background:
                                  isHovered("my_bets4") &&
                                  "var(--dark-theme-time-remaining)",
                                color: isHovered("my_bets4") && "white",
                              }}
                              onClick={() =>
                                navigate("/sports_bets", {
                                  state: { activeTab: 6 },
                                })
                              }
                              onMouseEnter={() => handleMouseEnter("my_bets4")}
                              onMouseLeave={handleMouseLeave}
                            >
                              <span _ngcontent-feu-c67="">
                                <img
                                  src="assets/icon/hh5.svg"
                                  style={{ height: "19px" }}
                                  className="img-fluid me-2"
                                  alt=""
                                />
                                Results
                              </span>
                            </p> */}
                            {/* <p
                              className="offcanvas_menu"
                              style={{
                                ...styles.offcanvas_menu,
                                background:
                                  isHovered("my_bets5") &&
                                  "var(--dark-theme-time-remaining)",
                                color: isHovered("my_bets5") && "white",
                              }}
                              onClick={() =>
                                navigate("/sports_bets", {
                                  state: { activeTab: 7 },
                                })
                              }
                              onMouseEnter={() => handleMouseEnter("my_bets5")}
                              onMouseLeave={handleMouseLeave}
                            >
                              <span _ngcontent-feu-c67="">
                                <img
                                  src="assets/icon/hh1.svg"
                                  style={{ height: "19px" }}
                                  className="img-fluid me-2"
                                  alt=""
                                />
                                Account Settlement
                              </span>
                            </p> */}
                            <p
                              className="offcanvas_menu"
                              style={{
                                ...styles.offcanvas_menu,
                                background:
                                  isHovered("my_bets6") &&
                                  "var(--dark-theme-time-remaining)",
                                color: isHovered("my_bets6") && "white",
                              }}
                              onMouseEnter={() => handleMouseEnter("my_bets6")}
                              onMouseLeave={handleMouseLeave}
                              onClick={() =>
                                navigate("/sports_bets", {
                                  state: { activeTab: 4 },
                                })
                              }
                            >
                              <span _ngcontent-feu-c67="">
                                <img
                                  src="assets/icon/hh2.svg"
                                  style={{ height: "19px" }}
                                  className="img-fluid me-2"
                                  alt=""
                                />
                                P&L Reports
                              </span>
                            </p>
                            <p
                              className="offcanvas_menu"
                              style={{
                                ...styles.offcanvas_menu,
                                background:
                                  isHovered("my_bets7") &&
                                  "var(--dark-theme-time-remaining)",
                                color: isHovered("my_bets7") && "white",
                              }}
                              onClick={() =>
                                navigate("/sports_bets", {
                                  state: { activeTab: 3 },
                                })
                              }
                              onMouseEnter={() => handleMouseEnter("my_bets7")}
                              onMouseLeave={handleMouseLeave}
                            >
                              <span _ngcontent-feu-c67="">
                                <img
                                  src="assets/icon/hh1.svg"
                                  style={{ height: "19px" }}
                                  className="img-fluid me-2"
                                  alt=""
                                />
                                Account Statement
                              </span>
                            </p>
                            <p
                              className="offcanvas_menu"
                              style={{
                                ...styles.offcanvas_menu,
                                background:
                                  isHovered("my_bets3") &&
                                  "var(--dark-theme-time-remaining)",
                                color: isHovered("my_bets3") && "white",
                              }}
                              onClick={() =>
                                navigate("/sports_bets", {
                                  state: { activeTab: 5 },
                                })
                              }
                              onMouseEnter={() => handleMouseEnter("my_bets3")}
                              onMouseLeave={handleMouseLeave}
                            >
                              <span _ngcontent-feu-c67="">
                                <img
                                  src="assets/icon/hh4.svg"
                                  style={{ height: "19px" }}
                                  className="img-fluid me-2"
                                  alt=""
                                />
                                Change Password
                              </span>
                            </p>
                          </>
                        )}
                        <p
                          className="offcanvas_menu"
                          style={{
                            ...styles.offcanvas_menu,
                            background: isHovered("logout1")
                              ? "var(--dark-theme-time-remaining)"
                              : undefined,
                            color: isHovered("logout1") ? "white" : undefined,
                          }}
                          onClick={() => {
                            setsidebaar(false);
                            logout();
                          }}
                          onMouseEnter={() => handleMouseEnter("logout1")}
                          onMouseLeave={handleMouseLeave}
                        >
                          <span>
                            <img
                              src="assets/icons/log-out.svg"
                              style={{ height: "19px" }}
                              className="img-fluid me-2"
                              alt="Logout"
                            />
                            Logout
                          </span>
                        </p>
                      </Offcanvas.Body>
                    </Offcanvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* The eleven-item nav that used to live here is now four
              top-level destinations with their sub-categories one level
              down. Shared with the logged-out header so the two cannot
              drift apart again. */}
          <RbNav liveCounts={{ cricket: livematch, football: footballLiveCount, tennis: tennisLiveCount }} />
        </div>
      )}
    </>
  );
};
